import MgSpaceItem from './mg-space-item.vue'
export default {
  name: 'MgSpace',
  props: {
    justify: String,
    align: String,
    direction: {
      type: String,
      default: 'horizontal',
      validator(value) {
        return ['horizontal', 'vertical'].includes(value)
      },
    },
    space: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    flexDirection() {
      return this.direction === 'vertical' ? 'column' : 'row'
    },
  },
  render(h) {
    const children = this.$slots?.default?.map((node) => h(MgSpaceItem, null, [node]))
    return h(
      'span',
      {
        style: {
          display: 'flex',
          flexDirection: this.flexDirection,
          justifyContent: this.justify,
          alignItems: this.align,
        },
      },
      [children]
    )
  },
}
